import React, { FC } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useIntl, FormattedMessage } from 'react-intl';
import { overrides } from '@cld/button';
import { Icon } from '@cld/icon';
import { globalTheme } from '@cld/component-theme';
import { typography } from '@cld/typography';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { Section } from '../common/Section';
import { messages } from '../../../i18n';
import { clearCredentials, clearOptions, clearMedia, clearResponse } from '../../../actions';
import { AuthState } from '../../../types';

const { Button } = overrides.mediaLibraryWidgetDemoOverrides;

const CloudNameContainer = styled.div`
  ${typography.xs.regular};
  margin-bottom: ${globalTheme.spacing.sm};
`;

const ChangeCloud = styled(Button)`
  margin-right: ${globalTheme.spacing.sm};
`;

export const General: FC<{ auth?: AuthState }> = ({ auth }) => {
  const analytics = useAnalytics();

  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const handleChangeCloud = () => {
    analytics('edit general', 'change cloud');
    dispatch(clearCredentials());
  };
  const handleResetSettings = () => {
    analytics('edit general', 'reset');
    dispatch(clearOptions());
    dispatch(clearMedia());
    dispatch(clearResponse());
  };

  return (
    <Section title={formatMessage(messages['demo.section.general'])}>
        {auth?.cloudName && (
          <CloudNameContainer>
            <FormattedMessage {...messages['demo.section.general.cloudName']} />:&nbsp;<span data-test="cloud-name">{auth.cloudName}</span>
          </CloudNameContainer>
        )}
      <ChangeCloud variant="secondary" size="sm" onClick={handleChangeCloud} id="change-cloud" data-test="change-cloud-button">
        <Icon name="cloud" />
        <FormattedMessage {...messages['demo.section.general.changeCloud']} />
      </ChangeCloud>
      <Button variant="secondary" size="sm" onClick={handleResetSettings} id="clear-options" data-test="reset-button">
        <Icon name="reset" />
        <FormattedMessage {...messages['demo.section.general.reset']} />
      </Button>
    </Section>
  );
};
